import React, { useContext } from 'react';
import { FormatPrice } from 'utils/format';
import moment from 'moment';

import { Flexer } from '@ontruck/orc';

import PrebookingAssignmentContext from 'modules/pre-booking/assignment/context';

const t_distance = {
  ES: 'Km',
  UK: 'Mi',
  FR: 'Km',
  NL: 'Km',
  EU: 'Km',
};

const HeaderInfo = ({ id }) => {
  const { prebookingsObject } = useContext(PrebookingAssignmentContext);

  const prebooking = prebookingsObject[id];

  if (!prebooking) {
    return null;
  }

  const { start_time, end_time, start_time_tz, end_time_tz, distance, amount, carrier, region } =
    prebooking;

  const start = moment(start_time).tz(start_time_tz);
  const end = moment(end_time).tz(end_time_tz);

  return (
    <>
      <Flexer.Child mLeft="XS" data-testid="booking_time">
        <strong>
          {start.format('HH:mm')} - {end.format('HH:mm')}
        </strong>
      </Flexer.Child>
      <Flexer.Child
        mLeft="XS"
        pLeft="XS"
        pRight="XS"
        flex="1"
        data-testid="booking_region"
        className="booking-region"
        title={region}
      >
        {region}
      </Flexer.Child>
      <Flexer.Child mLeft="XS" mRight="XS" flex="0" data-testid="booking_distance">
        {distance} {t_distance[carrier.country] || t_distance.ES}
      </Flexer.Child>
      <Flexer.Child mLeft="XS" flex="0" mRight="XS" data-testid="booking_amount">
        <FormatPrice currency={carrier.currency} value={amount} />
      </Flexer.Child>
    </>
  );
};

export default HeaderInfo;
